var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 335,
    viewBox: "0 0 140 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-26.1622 -2.80142e-06C-26.1622 -2.80142e-06 -2.22705 50.2591 56.984 41.3386C123.376 31.3303 151.87 89.3676 135.457 129.02C118.988 168.673 58.0668 165.899 56.1862 241.287C54.3056 318.308 -22.401 334.517 -22.401 334.517",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 58.0918C-44 58.0918 6.60587 79.849 56.9268 72.0708C107.248 64.2382 113.175 99.4304 107.248 113.409C95.0522 142.455 29.7432 148.058 25.5261 194.944C22.3347 230.191 47.5807 277.622 -9.69287 302.751",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.4322 81.535C-21.4322 81.535 30.2557 73.7025 21.0237 108.351C10.424 148.058 -14.4227 147.459 9.05626 197.718C17.4335 215.614 19.884 287.63 -26.1622 273.107",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4106 106.664C89.4106 98.3432 79.0006 91.5976 66.1593 91.5976C53.3179 91.5976 42.9079 98.3433 42.9079 106.664C42.9079 114.986 53.3179 121.731 66.1593 121.731C79.0006 121.731 89.4106 114.986 89.4106 106.664Z",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 335,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPattern);
export default __webpack_public_path__ + "static/media/left-pattern.3d03462e13f8c7181ff870e2116ae160.svg";
export { ForwardRef as ReactComponent };